



























import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import Vue from 'vue'
export default Vue.extend({
  props: {
    scope: {},
    options: {}
  },
  components: {
    infoRowsBlock
  }
})
